




























import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";

import { colorPlayerCount } from "./lib/helpers";

/**
 * Components
 */
import SimpleGroupCard from "@/components/_global/SimpleGroupCard.vue";
import CompositionsTabList from "./components/CompositionsTabList.vue";
import { GetOneCompositionGroupResponse } from "@/api/compositions/get-one-composition-group.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";

/**
 * API
 */

/**
 * Types
 */

/**
 * VueX Modules
 */

/**
 * Compositions' view page.
 */
@Component({
	components: {
		DataFetcher,
		SimpleGroupCard,
		CompositionsTabList
	}
})
export default class CompositionsWideViewPage extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;
	colorPlayerCount = colorPlayerCount;

	/// Props
	@Prop()
	compositionGroup!: GetOneCompositionGroupResponse | null;
	@Prop()
	notifyFetchCompositionGroup!: () => Promise<void>;

	/// Attributes
	isLoading = false;

	/// VueX Modules

	/// Methods
	async created() {
	}
	
	async fetch(){
		await this.fetchCompositionGroup();
	}

	async fetchCompositionGroup() {
		await this.notifyFetchCompositionGroup();
	}
}
